import { Traits } from '../interfaces/EventInterfaces'
import analyticsProviderFactory from './AnalyticsProviderFactory'

/**
 * Identify a user using the Segment provider.
 *
 * Example usage:
 *
 * IdentifySegmentUser({ email: 'user@example.com', name: 'John Doe' }, '12345');
 *
 * IdentifySegmentUser({ ...traits }, userId) if you maintain an object traits with user details.
 *
 * @param traits - The traits of the user.
 * @param userId - The optional user ID.
 */
const IdentifySegmentUser = async (
  traits: Traits,
  userId?: string
): Promise<void> => {
  const segmentProvider = analyticsProviderFactory.getProvider('segment')
  traits = normalizeBooleanString(traits)
  await segmentProvider?.identifyUser?.(traits, userId)
}

function normalizeBooleanString(traits: Traits): Traits {
  const normalizedTraits: Traits = {}

  for (const key in traits) {
    const value = traits[key]
    if (value === 'true') {
      normalizedTraits[key] = true
    } else if (value === 'false') {
      normalizedTraits[key] = false
    } else {
      normalizedTraits[key] = value
    }
  }

  return normalizedTraits
}

export default IdentifySegmentUser
